import { createContext } from 'react';
const MsContext = createContext({});
export default MsContext;
